//state PRovider from https://medium.com/simply/state-management-with-react-hooks-and-context-api-at-10-lines-of-code-baf6be8302c#:~:text=Hooks%20allows%20you%20to%20use,(i.e.%20without%20writing%20classes).&text=Quite%20easy%2C%20right%3F&text=First%20parameter%20of%20useReducer%20hook,parameter%20is%20an%20initial%20state.

export const StateContext = React.createContext();
export const StateProvider = ({reducer, appState, children}) =>(
  <StateContext.Provider value={React.useReducer(reducer, appState)}>
    {children}
  </StateContext.Provider>
);
export const useStateValue = () => React.useContext(StateContext);